import { Link } from 'react-router-dom';
import { Logo } from '@aosenuma/ui';

export function FooterBand() {
  return (
    <footer className="footer-band">
      <div className="footer-inner">
        <div className="powered">
          <span>Powered by</span>
          <Logo variant="aosenuma-icon-white" height={26} />
          <span className="name">aosenuma</span>
          <span>· earthscope</span>
        </div>
        {/* Footer legal entre `powered` y `footer-meta` (Diego: a la
            altura de los otros dos, misma fila). Solo SLA por ahora; el
            link al Aviso de Privacidad se restaurará cuando Aosenuma
            comparta la versión oficial validada. La página /aviso-privacidad
            sigue registrada en el router por si se accede directamente,
            pero no se promociona desde el footer. El inicio de sesión
            implica aceptación clickwrap del SLA vigente (§17 del SLA). */}
        <div className="footer-legal">
          <Link to="/sla" className="footer-legal-link">SLA</Link>
        </div>
        <div className="footer-meta">
          <strong>
            <a
              href="https://aosenuma.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-brand-link"
            >
              aosenuma
            </a>
            {' · 2026'}
          </strong>
          {' · 263.97 ha · 5 polígonos · 91 parcelas R0'}
        </div>
      </div>
    </footer>
  );
}
